import {css} from 'styled-components';
import {backgroundColor, primaryColor} from '../../ui/constants/colors';
import {mediaMinDesktop} from '../../ui/constants/customMedia';
import {
  fsL,
  fsM,
  fsMS,
  fsS,
  fsXL,
  fsXS,
  fwBold,
  fwLight,
} from '../../ui/constants/typography';

export const staticPageStyles = css`
  font-size: ${fsXS}px;
  line-height: 1.82;
  color: ${primaryColor};

  @media ${mediaMinDesktop} {
    font-size: ${fsS}px;
  }

  em,
  i {
    font-style: italic;
  }

  b,
  strong {
    ${fwBold}
  }

  a {
    text-decoration: underline;
    color: ${primaryColor};
  }

  h1 {
    font-size: ${fsL}px;
    line-height: 1.33;
    margin: 0 0 40px;

    @media ${mediaMinDesktop} {
      font-size: ${fsXL}px;
    }
  }

  h2 {
    font-size: ${fsM}px;

    @media ${mediaMinDesktop} {
      font-size: ${fsL}px;
    }
  }

  h3 {
    font-size: ${fsS}px;
    ${fwBold};

    @media ${mediaMinDesktop} {
      font-size: ${fsMS}px;
    }
  }

  p {
    margin: 20px 0;

    &:first-child {
      margin-top: 0;
    }
  }

  .static-content__section-navigation {
    display: block;
    font-size: ${fsS}px;
    text-decoration: none;
    ${fwBold};

    @media ${mediaMinDesktop} {
      font-size: ${fsMS}px;
    }
  }

  .static-content__text-padding {
    padding: 0 20px;
  }

  .static-content__text-2cols {
    column-count: 2;
    column-gap: 40px;
  }

  .static-content__section-headline {
    display: block;
    font-size: ${fsM}px;
    line-height: 1.4;
    border-bottom: 1px solid $outline;
    padding: 0 0 10px;
    margin: 40px 0 20px;
    ${fwLight};

    @media ${mediaMinDesktop} {
      font-size: ${fsL}px;
    }
  }

  .static-content__section-headline-notopmargin {
    margin-top: 0;
  }

  .static-content__section-subtitle {
    display: block;
    ${fwBold}
  }

  .static-content__red {
    padding: 10px;
    background-color: #f6dbd8;
  }

  .static-content__gray {
    padding: 10px;
    margin-bottom: 14px;
    background-color: ${backgroundColor};

    p {
      margin-bottom: 0;
    }

    h3 {
      margin-top: 0;
    }
  }

  .static-content__red {
    .static-content__section-headline {
      border-color: $granite;
      margin-top: 0;
    }
  }

  .static-content__unstyled-list {
    li {
      padding: 0;
      margin: 0;

      .static-content::before {
        display: none;
      }
    }
  }

  .static-content-form {
    margin: 20px 0;
    padding: 20px;
    background-color: $white;

    .static-content__title {
      font-size: ${fsMS}px;
      ${fwLight};

      @media ${mediaMinDesktop} {
        font-size: ${fsM}px;
      }
    }

    .static-content__element {
      margin-bottom: 5px;

      span {
        display: flex;
        flex-direction: row;
        width: 100%;
        align-items: flex-end;

        &::after {
          content: '';
          display: inline-block;
          flex-shrink: 1;
          height: 1px;
          background-color: $outline;
          flex-grow: 1;
          margin: 0 0 5px 5px;
        }
      }
    }
  }

  .accordion {
    margin: 10px 0;
  }
  .accordion__answer {
    display: none;

    p {
      &:first-child {
        margin: 0;
      }
    }
  }
  .accordion__question {
    ${fwBold}
    font-size: ${fsMS}px;
    cursor: pointer;
    p {
      margin: 0;
    }
  }

  input[type='checkbox'] {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    left: -9999px;

    &:checked {
      display: block;

      & + div {
        display: block;
      }
    }
  }

  .accordion input:checked .accordion__answer {
    display: block;
  }
`;
